import React, { createContext, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const AppContext = createContext();

export function AppProvider({ children }) {
  const { i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang)
    localStorage.setItem('i18n', lang);
  }

  useEffect( () => {
    i18n.changeLanguage(localStorage.getItem('i18n') || 'lv');
  }, []);

  return (
    <AppContext.Provider value={{
      changeLanguage
    }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  return useContext(AppContext);
}
